import { render, staticRenderFns } from "./pieItem.vue?vue&type=template&id=5017ff2f&scoped=true"
import script from "./pieItem.vue?vue&type=script&lang=js"
export * from "./pieItem.vue?vue&type=script&lang=js"
import style0 from "./pieItem.vue?vue&type=style&index=0&id=5017ff2f&prod&lang=scss&scoped=true"
import style1 from "./pieItem.vue?vue&type=style&index=1&id=5017ff2f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5017ff2f",
  null
  
)

export default component.exports